import { Box, Typography, styled } from '@material-ui/core';

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 14,
  marginTop: 8,
}));

export const ResendButtonBox = styled(Box)({
  marginTop: 32,
});

export const OtpInputContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  gap: 8,
  marginBottom: 8,
});

export const OtpInput = styled('input')(({ theme }) => ({
  width: 48,
  height: 56,
  fontSize: 24,
  fontWeight: 500,
  textAlign: 'center',
  border: `2px solid ${theme.palette.grey[400]}`,
  borderRadius: 8,
  outline: 'none',
  backgroundColor: 'transparent',
  transition: 'border-color 0.2s',
  '&::placeholder': {
    fontSize: 20,
    lineHeight: 1,
    color: theme.palette.grey[400],
  },
  '&:focus': {
    borderColor: theme.palette.primary.main,
  },
  '&.error': {
    borderColor: theme.palette.error.main,
  },
  '&:disabled': {
    backgroundColor: theme.palette.grey[100],
    cursor: 'not-allowed',
    opacity: 0.6,
  },
}));
